<template>
  <div>
    <!-- 动态插入HTML内容 -->
    <div ref="content"
         class="content"
         :style="{ maxHeight: isExpanded ? 'none' : '400px' }"
         v-html="htmlContent"></div>

    <!-- 展开/收起按钮 -->
    <div v-if="showToggleButton"
         class="toggle-button"
         @click="toggleContent">
      {{ isExpanded ? '收起' : '展开完整内容' }}
      <i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    htmlContent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
      showToggleButton: false,
    }
  },
  mounted() {
    this.checkContentHeight()
  },
  methods: {
    checkContentHeight() {
      // 检查内容高度是否超过400px
      let interval = setInterval(() => {
        const contentElement = this.$refs.content
        if (contentElement) {
          if (contentElement.scrollHeight > 0) {
            clearInterval(interval)
          }
          if (contentElement.scrollHeight > 400) {
            this.showToggleButton = true
          }
        } else {
          clearInterval(interval)
        }
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
      }, 10000)
    },
    toggleContent() {
      this.isExpanded = !this.isExpanded
    },
  },
  watch: {
    htmlContent: {
      handler() {
        this.$nextTick(() => {
          this.checkContentHeight()
        })
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.content {
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.toggle-button {
  margin-top: 10px;
  color: blue;
  cursor: pointer;
  text-align: center;
}
</style>
